<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-4"></a><span href="#/toc#toc-chapter003" title="Link target outside of Sample">Chapter 3</span></h1>
<h1 class="chapter-title"><span href="#/toc#toc-chapter003" title="Link target outside of Sample">Time Is Only a Perception</span></h1>
<p class="noindent">That was then.</p>
<p>This is now.</p>
<p class="space-break">He snuck in the back way as always, hoping that today his PA would get bored of trying to catch him. But there she was, as always, waiting at the bottom of the lift, papers in one hand, half-eaten egg and cress sandwich in the other.</p>
<p>He puts his face into neutral-yet-resilient and summons the lift. She slips in beside him, as if she’d casually been waiting at this place, at this time, a fortunate coincidence, two professionals having a chance encounter. And says, “Have you read it?”</p>
<p>“Good morning Mr Mayor, how are you? Why, isn’t it lovely if surprising to see you, I just happened to be passing!” he intones.</p>
<p>“Good morning, Mr Mayor. How are you?”</p>
<p>“I’m very well, thank you, Kelly, and yourself?”</p>
<p>“Absolutely topping, Mr Mayor, completely the best. Would you like a foot massage and a cup of tea before commencing the business of the day?”</p>
<p>He sighs. Every day they have this encounter, and every day it ends the same way. “What was the first question?”</p>
<p>“Have you read it?”</p>
<p><a id="page-5"></a>“Vague as that is, let’s play safe and go with no.”</p>
<p>“Mr Mayor—”</p>
<p>“Kelly, I’ve got things to do, people to see…”</p>
<p>“I really feel it’s important.”</p>
<p>“You said that last week, with the white paper on basilisk activity in the Barking sewage works.”</p>
<p>“Well, it is important–you can’t think it’s not.”</p>
<p>“I’m sure it’s important. I just wish you hadn’t tried to prove your point by sending me on a field trip.”</p>
<p>“Mr Mayor,” she tries again, at once wheedling and determined, “just take a look at <em>this</em>.”</p>
<p>She hands him a paper. Since she’s been his PA, Kelly has got good at knowing just how much paper to give him at any time. Only one sheet of A4 and he feels patronised; an entire folder and he won’t bother reading. Five to seven pages of essential notes have become the standard, with the really important stuff, the absolutely <em>vital</em> stuff, tucked in around page 3.</p>
<p>He reads page 1 and huffs. Flicks to page 2 and sighs. Gets to page 3, shows no reaction, turns to page 4 and…</p>
<p>… turns right back.</p>
<p>She watches his eyes dance over the words as the lift slows to a halt on the top floor. The doors open but he doesn’t move. His lips move silently as if the portion of his brain usually dedicated to absorbing this kind of information is crying out for assistance from any other interested lobes.</p>
<p>He says, “No but what?”</p>
<p>“You’ve found the…”</p>
<p>“Too bloody right, and no, but seriously, <em>what?”</em></p>
<p>“I told you it was important!”</p>
<p>“Yes but no but I mean sure, I get where this is coming from, but actually—”</p>
<p>“I’m told they get a lot of interest from Facebook.”</p>
<p>“Facebook! <em>Facebook?!</em> I’ve got a city infested with horrors of the night crawling from nether darkness; I’ve got monsters and demons and missing fucking goddesses and creatures whose footsteps burn the night and wards failing and meetings–bloody hell, I’ve got bloody fucking fiscal meetings with the directors’ board–and they’re doing this with <em>Facebook?!”</em></p>
<p><a id="page-6"></a>“That’s how I understand it, Mr Mayor.”</p>
<p>“Couldn’t someone tell them to stop?”</p>
<p>“I’m not sure that would be a good idea.”</p>
<p>“But it’s ridiculous!”</p>
<p>“I think it’s rather sweet.”</p>
<p>He looks up from the paper, and now there’s no attempt to keep the horror off his face.</p>
<p>“ ‘Sweet’?”</p>
<p>“Well, in its way…”</p>
<p>“Kelly, you’re a guardian of the night, a magician who wears black and not for its slimming properties; you’ve been trained in how to kill people in many different ways and when you’re not giving me bad news, you’re in theory running around the city hunting down all the things too nasty to be named, and you think this is <em>sweet?”</em></p>
<p>She thinks about it. “Beats blood-drenched midnight orgies.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter003.vue?19dbe4a0